module.exports = __webpack_public_path__ + "img/provider3.28d16a8e.png";